/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import EditIcon from "../../assets/img/edit.png";
import GetBlog from "../../Api/GetBlog";
import Form from 'react-bootstrap/Form';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Badge from 'react-bootstrap/Badge';
import FiltersForm from "../Common/FiltersForm";
import { useSelector, useDispatch } from "react-redux";
import { getBlogList } from "../../redux/actions/blogActions";
import { useNavigate, Link } from "react-router-dom";
import CommonModal from "../Common/CommonModal";
import Avatar from "../Common/Avatar";
import CommonLogout from "../Common/CommonLogout";
import moment from "moment";
import DeleteIcon from "../../assets/img/delete.png";
import CommonPagination from "../Common/CommonPagination";

const BlogManagement = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { accessToken } = useSelector((state) => state.personalReducers);
    const { blogList } = useSelector((state) => state.blogReducers);
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("all");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ showModal, setShowModal ] = useState({
        open: false,
        title: "",
        modalType: "",
        Data: {}
    });
    const [ paginationLength, setPaginationLength ] = useState({});

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };
    
    // clear search box
    const ClearSearchFiled = () => {
        setUserSearch("");
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    useEffect(() => {
        fetchData();
    }, [ userSearch, userType, userLimit, currentPage ]);

    // Get data from api
    const fetchData = async () => {
        const BlogsList = await GetBlog(accessToken, userSearch, userType, userLimit, currentPage);
        if(BlogsList?.status === 200) {
            dispatch(getBlogList(BlogsList.data));
            setPaginationLength(BlogsList.pagination);
        } else if(BlogsList?.status === 403) {
            CommonLogout();
            dispatch(getBlogList([]));
        } else {
            dispatch(getBlogList([]));
        };
    };

    // Charity active or deactive
    const BlogActivStatus = (blogs) => {
        setShowModal({
            ...showModal,
            open: !showModal?.open,
            title: "Are you sure?",
            description: `Do you really want to ${blogs?.is_active ? 'deactivate' : 'active'}`,
            modalType: "not form",
            button: "Yes",
            category: "Blog Active",
            Data: blogs
        });
    };

    // Delete charity 
    const DeleteBlog = (Charity) => {
        setShowModal({
            ...showModal,
            open: !showModal?.open,
            title: "Are you sure?",
            description: "Do you really want to delete",
            modalType: "not form",
            button: "Delete Blog",
            category: "Delete Blog",
            Data: Charity
        });
    };

    // add charity
    const AddBlog = () => {
        navigate("/add/blog");
    };

    return(<>
        <FiltersForm 
            filterType={"blog (Name)"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            ClearSearchFiled={ClearSearchFiled}
            SelectUserTypeFnct={SelectUserTypeFnct}
            AddBlog={AddBlog}
        />
        <div className="tableContent">
            <Scrollbars 
                style={{ height: paginationLength?.total_records > 10 ? "calc(100% - 87px)" : "calc(100% - 50px)" }} 
                className="ScrollbarsWrapper"
                renderView={props => <div {...props} className="view"/>}
            >
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Picture</th>
                                <th>Name</th>
                                <th>Category</th>
                                <th>Created At</th>
                                <th>User Active</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {blogList && blogList?.map((user, index) => {
                                return(<React.Fragment key={index}>
                                <tr>
                                    <td>
                                        <Avatar type={"product"} src={user?.avatar} title={user?.name}/>
                                    </td>
                                    <td>{user?.title}</td>
                                    <td>{user?.category}</td>
                                    <td>{moment(user.created_at).format('LL')}</td>
                                    <td>
                                        <Form className="switchbtn">
                                            <Form.Check 
                                                type="switch"
                                                id="custom-switch"
                                                checked={user?.is_active}
                                                onChange={e => {}}
                                                onClick={() => BlogActivStatus(user)}
                                            />
                                            <Badge bg={user?.is_active ? "primary" : "danger"}>{user?.is_active ? "Yes" : "No"}</Badge>
                                        </Form>
                                    </td>
                                    <td>
                                        <Link className="btn actionbtn" to={"/edit/blog/" + user?.slug} >
                                            <Image src={EditIcon} alt="edit icon" />
                                        </Link>
                                        <button className="btn actionbtn" onClick={() => DeleteBlog(user)}>
                                            <Image src={DeleteIcon} alt="delete icon" />
                                        </button>
                                    </td>
                                </tr>
                            </React.Fragment>)
                            })}
                            {blogList && blogList.length === 0 && <tr><td style={{ textAlign: "center" }} colSpan={8}>Blogs Not Found !</td></tr>}
                        </tbody>
                    </table>
                </div>
            </Scrollbars>
            {/* pagination */}
            {parseInt(paginationLength?.total_records) > 10 && (<CommonPagination 
                currentPage={currentPage}
                paginationLength={paginationLength}
                currentFunction={currentFunction}
            />)}
        </div>
        {showModal?.open && (<CommonModal showModal={showModal} setShowModal={setShowModal} />)}
    </>);
}

export default BlogManagement;